import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiRhyme } from '../utils/api';
import SeoContent from '../components/SeoContent';
import PageSEO from '../components/PageSEO';

export default function RhymeFinder() {
  const [word, setWord]       = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  async function handleSolve(e) {
    e.preventDefault();
    if (!word.trim()) return;
    setLoading(true); setError(''); setResults(null);
    try {
      const { data } = await apiRhyme(word);
      setResults(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong.');
    } finally { setLoading(false); }
  }

  const grouped = results?.results
    ? results.results.reduce((acc, r) => {
        const key = r.suffix.toUpperCase();
        (acc[key] = acc[key] || []).push(r);
        return acc;
      }, {})
    : {};

  const EXAMPLES = ['cat','love','day','moon','star'];

  return (
    <div className="game-page">
      <PageSEO page="rhyme" />
      <div className="container" style={{maxWidth:700}}>
        <Link to="/" className="back-btn"><i className="bi bi-arrow-left"></i> All Games</Link>

        <div className="game-header">
          <span className="game-icon">🎵</span>
          <h1>Rhyme Finder</h1>
          <p>Enter any word and discover words that rhyme with it — perfect for poetry!</p>
        </div>

        <div className="solver-card">
          <form onSubmit={handleSolve}>
            <div className="mb-3">
              <label className="fw-bold mb-1">Find Rhymes For</label>
              <input
                className="big-input"
                value={word}
                onChange={e => setWord(e.target.value.replace(/[^a-zA-Z]/g,''))}
                placeholder="e.g. MOON"
                maxLength={15}
                autoFocus
              />
              <div className="mt-2">
                <small className="text-muted fw-bold me-2">Try:</small>
                {EXAMPLES.map(ex => (
                  <button
                    key={ex} type="button"
                    className="btn btn-sm me-1 fw-bold"
                    style={{borderRadius:'50px',background:'var(--border)',border:'none',
                            fontFamily:'Nunito,sans-serif',fontSize:'0.8rem',padding:'0.2rem 0.7rem'}}
                    onClick={() => setWord(ex.toUpperCase())}
                  >{ex.toUpperCase()}</button>
                ))}
              </div>
            </div>
            <button type="submit" className="solve-btn" disabled={loading || !word}>
              {loading ? <><span className="spinner-border spinner-border-sm me-2"></span>Finding…</> : '🎵 Find Rhymes'}
            </button>
          </form>
        </div>

        {error && <div className="alert alert-danger alert-custom">{error}</div>}

        {results !== null && (
          <div className="solver-card">
            <p className="result-count">
              Found <strong>{results.count}</strong> rhyme{results.count !== 1 ? 's' : ''} for{' '}
              <strong style={{color:'var(--secondary)'}}>{word.toUpperCase()}</strong>
            </p>
            {results.count === 0 ? (
              <p className="text-muted">No rhymes found. Try a different word!</p>
            ) : (
              Object.entries(grouped)
                .sort((a,b) => b[0].length - a[0].length || a[0].localeCompare(b[0]))
                .map(([suffix, words]) => (
                  <div key={suffix} className="mb-3">
                    <h6 className="fw-bold mb-2">
                      <span style={{background:'#fce7f3',color:'#9d174d',padding:'0.2rem 0.7rem',borderRadius:'50px'}}>
                        -{suffix}
                      </span>
                      <small className="text-muted ms-2">({words.length})</small>
                    </h6>
                    <div className="words-cloud">
                      {words.map(r => (
                        <span key={r.word} className="rhyme-badge">{r.word.toUpperCase()}</span>
                      ))}
                    </div>
                  </div>
                ))
            )}
          </div>
        )}
      <SeoContent game="rhyme" />
      </div>
    </div>
  );
}
